export default __webpack_public_path__ + "static/media/trustwallet.ef7bddca.svg";